import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { PreAuths } from '../PreAuths';
import type { Tab } from '../types';

export function PreAuthsPage({ view }: { view?: Tab }) {
  usePageTopBar({ breadcrumb: ['Pre-auths'] });
  return <PreAuths {...(view ? { view } : {})} />;
}
